import { createRouter, createWebHistory } from 'vue-router';

// Импортируем наши компоненты
import MainLayout from '@/layouts/MainLayout.vue';
import IndexPage from '@/views/IndexPage.vue';
import ViewersList from '@/views/ToolCatalog.vue';
import ViewersDetail from '@/views/ViewersDetail.vue';
import CountersList from '@/views/ToolCatalog.vue';
import CountersDetail from '@/views/CountersDetail.vue';
import ConvertersList from '@/views/ToolCatalog.vue';
import ConverterDetail from '@/views/ConverterDetail.vue';
import CalculatorList from '@/views/ToolCatalog.vue';
import CalculatorDetail from '@/views/CalculatorDetail.vue';
import AtlasPage from '@/views/AtlasPage.vue';
import AtlasCategoryView from '@/views/AtlasCategoryView.vue';
import SmartHubUnified from '@/views/SmartHubUnified.vue';
import Catalog from '@/views/CatalogIndex.vue'
import DocumentDetails from '@/views/DocumentDetails.vue'
import LabCheckupGuide from '@/views/LabCheckupGuide.vue'

import ToolCatalog from '@/views/ToolCatalog.vue';
import ResearchPage from '@/views/ResearchPage.vue';
const routes = [
    { path: '/smarthub', redirect: '/labcheckup-online' },
    { path: '/smarthubirnfer', redirect: '/labcheckup-online' },
    { path: '/smarthublpnp', redirect: '/labcheckup-online' },
    {
        path: '/',
        component: MainLayout,
        children: [
            {path:'/workspace',component:ToolCatalog,name:'Workspace'},
            {path:'/research',component:ResearchPage,name:'Research'},
            {
                path: '',
                component: IndexPage,
                name: 'IndexPage'
            },
            {
                path: '/labcheckup-online',
                component: SmartHubUnified,
                name: 'LabCheckupOnline'
            },
            {
                path: '/labcheckup',
                component: LabCheckupGuide,
                name: 'LabCheckupGuide'
            },
            {
                path: '/viewers', 
                component: ViewersList,
                name: 'ViewersList'
            },
            {
                path: '/atlas', 
                component: AtlasPage,
                name: 'AtlasPage'
            },
            {
                path: '/atlas/:id', 
                component: AtlasCategoryView,
                name: 'AtlasCategoryView'
            },
            {
                path: '/catalog', 
                component: Catalog,
                name: 'Catalog'
            },
            {
                path: '/catalog/:id',
                name: 'DocumentDetails',
                component: DocumentDetails
            },
            {
                path: '/viewers/:id',  // новый роут с параметром id
                component: ViewersDetail,
                name: 'viewersDetail',
                props: true // Включите, если вы хотите передавать параметры как props в компонент
            },
            {
                path: '/counters', 
                component: CountersList,
                name: 'CountersList'
            },
            {
                path: '/counters/:id',  // новый роут с параметром id
                component: CountersDetail,
                name: 'CountersDetail',
                props: true // Включите, если вы хотите передавать параметры как props в компонент
            },
            {
                path: '/calculators', 
                component: CalculatorList,
                name: 'CalculatorList'
            },
            {
                path: '/calculators/:id', 
                component: CalculatorDetail,
                name: 'CalculatorDetail',
                props: true // Включите, если вы хотите передавать параметры как props в компонент
            },
            {
                path: '/converters', 
                component: ConvertersList,
                name: 'ConvertersList'
            },
            {
                path: '/converters/:id', 
                component: ConverterDetail,
                name: 'ConverterDetail',
                props: true // Включите, если вы хотите передавать параметры как props в компонент
            },
        ]
    }
];

const router = createRouter({
    scrollBehavior() {return {top:0};},
    history: createWebHistory(),
    linkActiveClass: '',
    routes
});

export default router;
